import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActivateComponent } from './components/activate/activate.component';

const routes: Routes = [{ path: '', component: ActivateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivatePageRoutingModule {}
